// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8144f09b","455":"19f9baaf","977":"6a5404ab"}[chunkId] + ".chunk.js";
};